<div class="product-overview">
  <header>
    <div class="header-left">
      <h2>Product Overview</h2>
      <div *ngIf="productName" class="product-name">{{productName}}</div>
    </div>
    <div class="header-right">
      <div class="close" (click)="close()"></div>
    </div>
  </header>

  <div *ngIf="loading" class="loading">Loading . . .</div>
  <div *ngIf="loadError" class="error-bar"><div class="error">{{loadError}}</div></div>

  <div *ngIf="!loading && !loadError" class="overview-body">

    <section class="info-section">
      <div class="section-title">Product Information</div>
      <div class="info-grid">
        <div class="info-item" *ngFor="let info of infoFields">
          <div class="info-label">{{info.name}}</div>
          <div class="info-value">{{info.value}}</div>
        </div>
      </div>
    </section>

    <div class="panel-row" *ngIf="overview && overview.priceHistory?.length">
      <section class="side-panel">
        <div class="section-title">Price History</div>
        <div class="panel-item" *ngFor="let change of overview.priceHistory">
          <div class="panel-main">
            {{formatCents(change.oldValue)}} <span class="arrow">&rarr;</span> {{formatCents(change.newValue)}}
          </div>
          <div class="panel-sub">{{shortDate(change.time)}} · {{change.userName}}</div>
        </div>
      </section>
    </div>

    <section class="qty-section" *ngIf="overview">
      <div class="section-title">Inventory &amp; Sales by Location</div>
      <div class="not-countable" *ngIf="notCountable">
        This item is not inventory countable. Sales are tracked, but on-hand quantities are not reported for it.
      </div>
      <div class="qty-scroll wide">
        <table>
          <thead>
            <tr>
              <th class="loc">Location</th>
              <th class="num">On Hand</th>
              <th class="num">Sold 7 Days</th>
              <th class="num">Sold 30 Days</th>
              <th class="num">Days Supply</th>
              <th class="num">Sell-Through 30d</th>
              <th class="num">In Transit</th>
              <th class="num">On Order</th>
              <th class="num" *ngIf="showReplenishTarget">Replenish Target</th>
              <th class="num">Last Sold</th>
              <th class="num">Last Received</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of overview.rows">
              <th class="loc">
                {{row.name}}
                <span class="loc-type" *ngIf="row.type !== 'retail'">{{row.type}}</span>
              </th>
              <td class="num" [class.zero]="!row.onHand" [class.negative]="row.onHand < 0">{{notCountable ? '—' : (row.onHand | rf:'number')}}</td>
              <td class="num" [class.zero]="!row.d7">{{row.d7 | rf:'number'}}</td>
              <td class="num" [class.zero]="!row.d30">{{row.d30 | rf:'number'}}</td>
              <td class="num" [class.low]="!notCountable && daysSupplyLow(row)" [class.zero]="notCountable || daysSupply(row) === '—'">{{notCountable ? '—' : daysSupply(row)}}</td>
              <td class="num" [class.zero]="notCountable || sellThrough(row) === '—'">{{notCountable ? '—' : sellThrough(row)}}</td>
              <td class="num" [class.zero]="!row.inTransit">{{row.inTransit | rf:'number'}}</td>
              <td class="num" [class.zero]="!row.onOrder">{{row.onOrder | rf:'number'}}</td>
              <td class="num" *ngIf="showReplenishTarget" [class.zero]="!row.replenishTarget">{{row.replenishTarget | rf:'number'}}</td>
              <td class="num date" [class.zero]="!row.lastSold">{{shortDate(row.lastSold)}}</td>
              <td class="num date" [class.zero]="!row.lastReceived">{{shortDate(row.lastReceived)}}</td>
            </tr>
            <tr class="totals-row">
              <th class="loc">Company Total</th>
              <td class="num" [class.negative]="overview.totals.onHand < 0">{{notCountable ? '—' : (overview.totals.onHand | rf:'number')}}</td>
              <td class="num">{{overview.totals.d7 | rf:'number'}}</td>
              <td class="num">{{overview.totals.d30 | rf:'number'}}</td>
              <td class="num" [class.low]="!notCountable && daysSupplyLow(overview.totals)">{{notCountable ? '—' : daysSupply(overview.totals)}}</td>
              <td class="num">{{notCountable ? '—' : sellThrough(overview.totals)}}</td>
              <td class="num">{{overview.totals.inTransit | rf:'number'}}</td>
              <td class="num">{{overview.totals.onOrder | rf:'number'}}</td>
              <td class="num" *ngIf="showReplenishTarget">{{overview.totals.replenishTarget | rf:'number'}}</td>
              <td class="num date">{{shortDate(overview.totals.lastSold)}}</td>
              <td class="num date">{{shortDate(overview.totals.lastReceived)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

  </div>

  <!-- Print only: position:fixed repeats on every printed page. -->
  <div class="print-footer">{{productName}}<span *ngIf="overview?.itemNumber"> &middot; Item # {{overview.itemNumber}}</span> &middot; {{shortDate(reportDate)}}</div>
</div>
